import { useQuery } from "@tanstack/react-query";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import {
	type FetchArgsOptions,
	getTaskV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useTaskListQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	limit?: number,
	offset?: number,
	options?: FetchArgsOptions,
) => {
	return useQuery({
		queryKey: TaskKeys.list(),
		queryFn: processResponse(() =>
			getTaskV2(
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				limit,
				offset,
				options,
			),
		),
	});
};
